import React, { createContext, useState, useContext } from 'react';

// Create the context
const ThankYouMessageContentContext = createContext();

// Create a provider component
export const ThankYouMessageContentProvider = ({ children }) => {
    const [thankYouMessageContent, setThankYouMessageContent] = useState('');

    return (
        <ThankYouMessageContentContext.Provider value={{ thankYouMessageContent, setThankYouMessageContent }}>
            {children}
        </ThankYouMessageContentContext.Provider>
    );
};

// Custom hook to use the ThankYouMessageContentContext
export const useThankYouMessageContent = () => {
    return useContext(ThankYouMessageContentContext);
};
